var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42726",
    "data-name": "Group 42726",
    transform: "translate(9427 -7379)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15989",
    "data-name": "Rectangle 15989",
    width: 280,
    height: 280,
    transform: "translate(-9427 7379)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42725",
    "data-name": "Group 42725",
    transform: "translate(-9409.496 7400.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M697.127-2192.563a113.617,113.617,0,0,1-113.619,113.616,113.617,113.617,0,0,1-113.618-113.616,113.618,113.618,0,0,1,113.618-113.619,113.618,113.618,0,0,1,113.619,113.619",
    transform: "translate(-452.135 2306.182)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M484.209-1671.191a15.843,15.843,0,0,1-11,11.563l-95.828,27.842a15.851,15.851,0,0,1-19.643-10.8l-33.662-115.864a15.848,15.848,0,0,1,10.8-19.641L394.8-1795.5l35.9-10.429a15.851,15.851,0,0,1,19.643,10.8L484-1679.269a15.773,15.773,0,0,1,.206,8.077",
    transform: "translate(-323.441 1867.168)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M958.193-1671.193l-80.393-4.613a15.849,15.849,0,0,1-14.916-16.732l5.9-102.966,35.9-10.429a15.852,15.852,0,0,1,19.644,10.8l33.661,115.864a15.758,15.758,0,0,1,.205,8.077",
    transform: "translate(-797.433 1867.168)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M978.865-1845.828H879.073a15.852,15.852,0,0,1-15.85-15.851V-1982.33a15.849,15.849,0,0,1,15.85-15.851h99.791a15.849,15.849,0,0,1,15.85,15.851v120.652a15.852,15.852,0,0,1-15.85,15.851",
    transform: "translate(-797.747 2035.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M1619.984-1121.329l.984,1.175c-.131.133-.26.265-.394.4q-1.321,1.321-2.781,2.544t-2.986,2.3l-.695.476c-.077.052-.153.105-.232.153l-.949-1.129-.541-.645-.542-.643c.232-.159.462-.319.695-.477q1.534-1.083,2.986-2.3t2.778-2.543c.205-.2.4-.4.593-.6l.544.649.539.645",
    transform: "translate(-1455.571 1266.198)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M1707.692-1016.545l-1.121.942-5.931,4.977-3.653-4.346-.536-.644-.539-.643-5.236-6.24q.111-.08.23-.16c.224-.163.454-.327.681-.49,1.006-.737,2-1.515,2.967-2.324s1.9-1.656,2.8-2.521c.134-.127.268-.258.4-.391l5.212,6.211.536.64.536.639,2.713,3.228.941,1.122",
    transform: "translate(-1524.84 1183.39)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M1744.218-939.441l-32.588-38.842a3.232,3.232,0,0,1,.4-4.562l11.386-9.557a3.239,3.239,0,0,1,4.561.4l32.594,38.842a7.579,7.579,0,0,1-.935,10.676l-4.739,3.976a7.58,7.58,0,0,1-10.678-.932",
    transform: "translate(-1542.576 1152.428)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M1644.444-1091.825c-.131.133-.265.264-.4.391-.905.865-1.835,1.7-2.806,2.521s-1.96,1.587-2.964,2.324c-.227.163-.457.33-.684.49-.077.053-.153.107-.227.16l-2.748-3.27-.539-.645-.542-.645-4.955-5.9c.079-.052.156-.105.235-.156.23-.156.462-.316.695-.474q1.53-1.087,2.983-2.3t2.783-2.544c.131-.133.263-.265.391-.4l4.922,5.86.539.643.544.645,2.77,3.3",
    transform: "translate(-1470.274 1248.318)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M980.266-1808.5a43.842,43.842,0,0,1,61.7,5.4,43.859,43.859,0,0,1-1.447,57.941c-.191.2-.384.407-.581.607s-.388.4-.591.6q-1.319,1.321-2.78,2.543t-2.987,2.3c-.23.156-.462.317-.693.476s-.468.312-.7.465a43.47,43.47,0,0,1-27.584,6.839,43.515,43.515,0,0,1-29.731-15.482A43.84,43.84,0,0,1,980.266-1808.5Zm70.63-2.094a55.452,55.452,0,0,0-78.122-6.836,55.449,55.449,0,0,0-6.833,78.121,55.455,55.455,0,0,0,73.783,10.131c.232-.159.462-.317.689-.481s.458-.323.684-.489q1.51-1.1,2.965-2.324t2.8-2.519c.2-.194.4-.385.6-.585s.4-.4.595-.6a55.456,55.456,0,0,0,2.837-74.421",
    transform: "translate(-876.615 1888.114)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M1118.912-1666.771c-.193.205-.384.41-.581.61s-.39.4-.592.6q-1.317,1.321-2.779,2.543t-2.986,2.305c-.231.156-.462.317-.692.473s-.469.312-.7.465a43.465,43.465,0,0,1-27.582,6.839,43.5,43.5,0,0,1-29.732-15.482,43.835,43.835,0,0,1,5.4-61.693,43.838,43.838,0,0,1,61.7,5.4A43.861,43.861,0,0,1,1118.912-1666.771Zm2.086-58.483a44.633,44.633,0,0,0-62.876-5.5,44.632,44.632,0,0,0-5.5,62.877,44.636,44.636,0,0,0,58.5,8.747c.237-.153.468-.309.7-.468s.459-.312.688-.479q1.528-1.074,2.989-2.3c.972-.812,1.9-1.663,2.784-2.54.2-.2.4-.4.593-.6s.387-.4.581-.61a44.645,44.645,0,0,0,1.542-59.131",
    transform: "translate(-954.996 1809.725)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M1125.114-1660.569c-.19.205-.381.41-.578.612s-.388.4-.592.6q-1.321,1.321-2.779,2.546t-2.986,2.3c-.231.161-.461.32-.695.476s-.465.314-.7.468a43.476,43.476,0,0,1-27.586,6.839,43.526,43.526,0,0,1-29.732-15.482,43.842,43.842,0,0,1,5.4-61.7,43.841,43.841,0,0,1,61.7,5.4,43.855,43.855,0,0,1-1.449,57.939",
    transform: "translate(-961.209 1803.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M1846.878-909.268a1.463,1.463,0,0,1-1.11-.507l-26.542-30.659a1.461,1.461,0,0,1,.148-2.064,1.463,1.463,0,0,1,2.067.149l26.545,30.656a1.47,1.47,0,0,1-.15,2.067,1.466,1.466,0,0,1-.957.358",
    transform: "translate(-1637.469 1108.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M1071.313-1781.211a1.073,1.073,0,0,1-.66-.23,1.067,1.067,0,0,1-.181-1.5,51.843,51.843,0,0,1,12.208-11.269,52.317,52.317,0,0,1,14.943-6.8,51.629,51.629,0,0,1,33.22,1.854,1.07,1.07,0,0,1,.6,1.392,1.068,1.068,0,0,1-1.391.6,50.213,50.213,0,0,0-57.892,15.55,1.071,1.071,0,0,1-.844.41",
    transform: "translate(-979.66 1863.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M1011.889-1593.018a1.023,1.023,0,0,1-.4-.079,1.068,1.068,0,0,1-.6-1.389,52.828,52.828,0,0,1,4.029-8.014,1.071,1.071,0,0,1,1.472-.35,1.073,1.073,0,0,1,.351,1.474,50.51,50.51,0,0,0-3.865,7.684,1.073,1.073,0,0,1-.994.676",
    transform: "translate(-927.44 1688.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M1260.408-1529.571a5.446,5.446,0,0,1-4.155.9,5.255,5.255,0,0,1-3.57-2.27,5.319,5.319,0,0,1-.891-4.2,5.426,5.426,0,0,1,2.319-3.563,5.53,5.53,0,0,1,4.214-.943,5.337,5.337,0,0,1,3.613,2.33,5.25,5.25,0,0,1,.848,4.143A5.522,5.522,0,0,1,1260.408-1529.571Zm-8.906-13.048q-2.6,1.8-5.34-1.406l-4.115-5.193a4.227,4.227,0,0,1-1.12-3.109,5.732,5.732,0,0,1,1.513-3.049,10.309,10.309,0,0,0,2.633-4.985,6.478,6.478,0,0,0-1.239-4.9,7.247,7.247,0,0,0-4.318-3.224,6.312,6.312,0,0,0-5.086,1.23,6.294,6.294,0,0,0-3.069,5.775,8.172,8.172,0,0,1-.557,3.6,4.635,4.635,0,0,1-2.253,1.906,4.883,4.883,0,0,1-3.551.353,2.98,2.98,0,0,1-1.986-2.691,14.56,14.56,0,0,1,1.185-8.312,16.715,16.715,0,0,1,5.936-6.858,17.95,17.95,0,0,1,7.6-3.145,13.046,13.046,0,0,1,7.343,1.006,14.842,14.842,0,0,1,6.073,5.318,11.511,11.511,0,0,1,2.163,8.772,17.638,17.638,0,0,1-4.4,8.564l3.053,4.947q2.073,3.654-.468,5.406",
    transform: "translate(-1113.75 1665.252)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.1c1012772e0722e534ecd50a3159e7a2.svg";
export { ForwardRef as ReactComponent };